/* eslint-disable */
import { useNavigate } from 'react-router-dom'
import '../../globalStyle.scss'
import AllPersonDataList from './AllPersonDataList'
import { useApiGet } from '../../apiCalls/useApi'
import { getAllProvidersByPagination } from '../../apiCalls/alertsApi'
import { useContext, useEffect, useState } from 'react'
import { OrgAppContext } from '../../OrgAppContext'
import { getProviderLabel } from '../../utils/provider'

export default function AllProviders() {
  const { customerId, appId } = useContext(OrgAppContext)
  const callGetAllProvidersByPaginationApi = useApiGet(getAllProvidersByPagination)
  const [data, setData] = useState({ data: [], total: 0 })
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 25,
    page: 0,
  })
  const navigate = useNavigate()

  useEffect(() => {
    if (appId) {
      setIsLoading(true)
      callGetAllProvidersByPaginationApi({
        appId,
        limit: paginationModel.pageSize,
        offset: paginationModel.page * paginationModel.pageSize,
      }).then((res: any) => {
        if (res?.data) {
          setData({ data: res.data, total: res.total })
          setIsLoading(false)
        }
      })
    }
  }, [appId, paginationModel])

  const columns = [
    {
      field: 'id',
      headerName: getProviderLabel(customerId, 'id'),
      flex: 1,
      renderCell: (params: any) => (
        <div
          className='linkStyle'
          onClick={() => {
            navigate(`/provider/providerInvestigation`, { state: { searchID: params.value } })
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
    },
    {
      field: 'firstAccessTime',
      headerName: 'First Access Time',
      flex: 1,
    },
    {
      field: 'lastAccessTime',
      headerName: 'Last Access Time',
      flex: 1,
    },
  ]

  return (
    <AllPersonDataList
      data={data.data}
      columns={columns}
      paginationModel={paginationModel}
      setPaginationModel={setPaginationModel}
      total={data.total}
      isLoading={isLoading}
    />
  )
}
